module.exports = __webpack_public_path__ + "static/media/oetker-digital-1x.4ff75b92.jpg";